export function getMediaUri(path) {
  return `https://segim-edu.s3.ap-northeast-2.amazonaws.com/media/${path}`;
}
